import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {CustomerInteractionDto} from "../../../model/dto/entity/customer-interaction.dto";
import {CustomerFormDto} from "../../../model/dto/entity/customer-form.dto";
import {CustomerInteractionDocumentDto} from "../../../model/dto/entity/customer-interaction-document.dto";
import {ConfirmationService} from "primeng/api";
import {CustomerInteractionService} from "../../../service/api/customer-interaction.service";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../core/shared/widget/widget-data-param";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestComplex} from "../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../core/shared/dto/object/request/object-request-relation";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";


@Component({
    selector: 'cr-customer-interaction-object-component',
    templateUrl: 'cr-customer-interaction-object.component.html',
    standalone: false
})
export class CrCustomerInteractionObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {
    customerFormService: MvsCrudService;
    // 14-05-2025   moved to core as it was needed in cross modules
    activeIndex: number = 0;
    basicWidgetData: WidgetData;
    customerFormWidget: WidgetData;
    dto: CustomerInteractionDto;
    customerForm: CustomerFormDto;
    customerInteractionDocumentDto: CustomerInteractionDocumentDto[];

    constructor(
        protected coreService: MvsCoreService,
        protected confirmationService: ConfirmationService,
        protected messageService: MvsMessageService,
        protected observerService: ObserverService,
        protected customerInteractionService: CustomerInteractionService,
        protected navigationService: MvsObjectNavigationService) {

        super(coreService, messageService, confirmationService, observerService);


        this.customerFormService = this.coreService.getCrudService("cr.CustomerForm");
    }

    handleActiveIndex() {
        if (this.activeIndex == 1) {
            this.getCustomerForm();
        } else if (this.activeIndex == 2) {
            if(this.customerInteractionDocumentDto){
                this.customerInteractionDocumentDto = undefined;
            }
            this.getCustomerInteractionDocs();
        }
    }

    /**
     * On Object Change.
     */
    onObjectChanged() {

        this.basicWidgetData = WidgetFactory.createWidgetTransient(
            'cr.customer.interaction.widget.data',
            "Customer Interaction",
            'data',
            'transient',
            'transient',
            'cr.CustomerInteraction',
            this.dto,
            new WidgetDataParam("objectId", this.dto.id)
        );

        if (this.dto.customerFormDtoId) {
            this.handleActiveIndex()
        }

    }

    getCustomerForm() {
        this.customerFormService.get(this.dto.customerFormDtoId).subscribe((res: CustomerFormDto) => {
            this.customerForm = res;

            this.customerFormWidget = WidgetFactory.createWidgetTransient(
                `cr.customer.interaction.customer.form.data.widget.${res.typeDtoId}`,
                'Customer Form',
                'data',
                'transient',
                'transient',
                'cr.CustomerForm',
                res,
                new WidgetDataParam("objectId", res.id)
            );

        });
    }

    getCustomerInteractionDocs() {

        if (this.busy) {
            return;
        }
        this.busy = true;
        const filterCriteria = FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        const objectComplexRequest = ObjectRequestComplex.build(true, false,
            ObjectRequestComplexNode.createRelationNode('CustomerInteractionDocs', ObjectRequestRelation.createJoin('cr.CustomerInteractionDocument#customerInteraction'))
                .addNodes(ObjectRequestComplexNode.createSimpleAttributeNode('document'))
        );
        const objectRequest = ObjectRequestList.createComplexRequestList(true, objectComplexRequest, [filterCriteria], [], null);
        this.customerInteractionService.list(objectRequest).subscribe(response => {
                this.customerInteractionDocumentDto = response.entries[0].CustomerInteractionDocs;
                this.busy = false;
            },
            error => {
                this.busy = false;
                console.error(error);
            }
        )
    }

    openDocument(document: CustomerInteractionDocumentDto) {
        const entry = MvsObjectNavigationEntry.createNavigationEntry('dm.DmDocument', document.documentDtoId,
            null,
            "Dokument " + document.name,
            null,
            null,
            MvsObjectNavigationActionEnum.any);

        this.navigationService.navigateTo(entry, "left");
    }

    openDocumentInNewWindow(document: CustomerInteractionDocumentDto) {
        const entry = MvsObjectNavigationEntry.createNavigationEntry('dm.DmDocument', document.documentDtoId, null, null, null, null, MvsObjectNavigationActionEnum.any, 'side');
        this.navigationService.openObjectInNewTab(entry);
    }

    handledDocumentLoad(blob: string, document: CustomerInteractionDocumentDto) {
        document['blob'] = blob;
    }

    downloadBlob(blobOrUrl: Blob | string, filename: string): void {
        let url: string;

        if (blobOrUrl instanceof Blob) {
            url = URL.createObjectURL(blobOrUrl);
        } else if (typeof blobOrUrl === 'string') {
            url = blobOrUrl;
        } else {
            console.error('Invalid blob type');
            return;
        }

        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'download';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        if (blobOrUrl instanceof Blob) {
            URL.revokeObjectURL(url);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
